export default __webpack_public_path__ + "static/media/45738-1000x830-1712946127896.6ba09723.jpg";